/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G3_TInputs */

const en_mk_sec_pg_g3_t = /** @type {(inputs: Mk_Sec_Pg_G3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional web access`)
};

const id_mk_sec_pg_g3_t = /** @type {(inputs: Mk_Sec_Pg_G3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses web opsional`)
};

/**
* | output |
* | --- |
* | "Optional web access" |
*
* @param {Mk_Sec_Pg_G3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g3_t = /** @type {((inputs?: Mk_Sec_Pg_G3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g3_t(inputs)
	return en_mk_sec_pg_g3_t(inputs)
});